// Width of the trailing action column in the PR list view, shared by the row
// (PrCardList) and the column header (search/InfiniteHits) so their columns stay
// aligned. The row fills this column with its content; the header reserves it as
// empty space. Signed-in rows fit the "Start a Conversation" button + bookmark;
// signed-out rows hold only the bookmark.
const prListActionColumnWidth = (isSignedIn) => (isSignedIn ? 220 : 24);

export default prListActionColumnWidth;
